import React, { useState } from 'react';

const MapFrame = ({ url, customData, interactive = true, className = "" }) => {
    const [hoveredZone, setHoveredZone] = useState(null);

    if (!url) return (
        <div className="w-full h-full bg-primary-50 flex items-center justify-center">
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-300">Map</span>
        </div>
    );

    const activeZone = customData?.zones?.find(z => z.id === hoveredZone);

    return (
        <div className={`relative w-full h-full overflow-hidden ${className}`}>
            {/* --- LAYER 1: THE MAP CANVAS --- */}
            <iframe
                src={url}
                title="Service Area Map"
                className={`
                    w-full h-full transition-all duration-700 grayscale-[0.15]
                    ${!interactive ? 'pointer-events-none' : 'pointer-events-auto'}
                `}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
            />

            {/* --- LAYER 2: THE LOCATION MARKERS (SVG) --- */}
            {customData?.zones && (
                <div className="absolute inset-0 pointer-events-none">
                    <svg className="w-full h-full pointer-events-auto" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
                        {customData.zones.map(pin => (
                            <g
                                key={pin.id}
                                className="cursor-pointer pointer-events-auto group/pin"
                                onMouseEnter={() => setHoveredZone(pin.id)}
                                onMouseLeave={() => setHoveredZone(null)}
                            >
                                {/* Location pin (orange, white outline) */}
                                <circle
                                    cx={pin.x}
                                    cy={pin.y}
                                    r="1.6"
                                    className="fill-secondary-500 stroke-white stroke-[0.5px] transition-all group-hover/pin:r-2"
                                />
                            </g>
                        ))}
                    </svg>
                </div>
            )}

            {/* --- LAYER 3: FLOATING TOOLTIP --- */}
            <div className={`
                absolute bottom-6 left-6 z-20 transition-all duration-500 
                ${activeZone ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}
            `}>
                <div className="min-w-[180px] rounded-2xl border border-primary-100 bg-white/95 p-4 shadow-xl backdrop-blur">
                    <h4 className="font-secondary text-sm font-bold uppercase text-primary-500">
                        {activeZone?.label}
                    </h4>
                    <p className="text-[11px] font-semibold text-primary-300">
                        {activeZone?.info}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MapFrame;